export const demoConnection = {
  connection_id: 'local-preview',
  ad_account_id: 'act_1029384756',
  token: { expires_at: null },
};

export const demoAdAccounts = [
  { ad_account_id: 'act_1029384756', name: "Dave's Garage", account_status: 1, currency: 'USD' },
  { ad_account_id: 'act_5647382910', name: "Dave's Garage — West", account_status: 1, currency: 'USD' },
];

export const demoCampaigns = [
  { platform_campaign_id: '101', name: 'Brake Service — Local', status: 'ACTIVE', daily_budget: 4500, imported_at: '2026-08-14T16:00:00Z' },
  { platform_campaign_id: '102', name: 'Oil Change Special', status: 'ACTIVE', daily_budget: 3000, imported_at: '2026-08-14T16:00:00Z' },
  { platform_campaign_id: '103', name: 'Summer AC Repair', status: 'PAUSED', daily_budget: 2500, imported_at: '2026-08-12T16:00:00Z' },
];

export const demoRecommendations = [
  {
    id: 'demo-rec-1',
    title: 'Put more budget behind Brake Service',
    campaign_name: 'Brake Service — Local',
    rationale: 'This campaign is generating calls 28% below your average cost and is reaching its daily limit early.',
    priority: 'high',
    status: 'proposed',
    suggested_values: { current_budget_cents: 4500, new_budget_cents: 5200, change_pct: 16, direction: 'boost' },
  },
  {
    id: 'demo-rec-2',
    title: 'Ease spend on Oil Change Special',
    campaign_name: 'Oil Change Special',
    rationale: 'Cost per call increased for four days while local demand softened. A small reduction protects this week’s budget.',
    priority: 'medium',
    status: 'proposed',
    suggested_values: { current_budget_cents: 3000, new_budget_cents: 2700, change_pct: -10, direction: 'reduce' },
  },
];

export const demoActivity = {
  applies: [
    {
      id: 'demo-apply-1', status: 'applied', campaign_name: 'Brake Service — Local',
      processing_id: 'adpilot-apply-demo-001',
      before_state: { current_budget_cents: 4000 }, requested_state: { new_budget_cents: 4500 },
      applied_at: '2026-08-16T16:42:00Z',
    },
  ],
  runs: [
    { id: 'demo-run-1', processing_id: 'adpilot-daily-demo-001', status: 'completed', campaign_name: 'Brake Service — Local', reporting_start_date: '2026-08-11', reporting_end_date: '2026-08-17', recommendation_count: 1, open_recommendation_count: 1, started_at: '2026-08-17T14:15:00Z' },
    { id: 'demo-run-2', processing_id: 'adpilot-daily-demo-002', status: 'completed', campaign_name: 'Oil Change Special', reporting_start_date: '2026-08-11', reporting_end_date: '2026-08-17', recommendation_count: 0, open_recommendation_count: 0, started_at: '2026-08-17T14:15:00Z' },
  ],
};

export const demoPerformance = {
  windows: {
    current: { since: '2026-08-11', until: '2026-08-17' },
    previous: { since: '2026-08-04', until: '2026-08-10' },
  },
  campaigns: [
    {
      platform_campaign_id: '101', name: 'Brake Service — Local',
      current: { spend: 286.4, impressions: 18420, clicks: 412, ctr: 2.24, results: 31, cost_per_result: 9.24, currency: 'USD' },
      previous: { spend: 251.1, impressions: 17210, clicks: 331, ctr: 1.92, results: 23, cost_per_result: 10.92, currency: 'USD' },
      change: { spend_pct: 14.06, clicks_pct: 24.47, ctr_points: 0.32, results_pct: 34.78 },
    },
    {
      platform_campaign_id: '102', name: 'Oil Change Special',
      current: { spend: 173.2, impressions: 15110, clicks: 248, ctr: 1.64, results: 18, cost_per_result: 9.62, currency: 'USD' },
      previous: { spend: 198.6, impressions: 15920, clicks: 236, ctr: 1.48, results: 16, cost_per_result: 12.41, currency: 'USD' },
      change: { spend_pct: -12.79, clicks_pct: 5.08, ctr_points: 0.16, results_pct: 12.5 },
    },
  ],
};
